import { NavLink } from "react-router-dom";

const navItems = [
  { to: "/", label: "About" },
  { to: "/skills", label: "Skills" },
  { to: "/projects", label: "Projects" },
  { to: "/education", label: "Education" },
  { to: "/experience", label: "Experience" },
];

const navItemBaseClass =
  "w-24 cursor-pointer select-none [border-radius:calc(12px_+_1rem)] p-[6px] text-center text-portfolio-muted no-underline hover:bg-portfolio-surface max-[1024px]:w-24 max-[1024px]:bg-portfolio-page max-[1024px]:hover:bg-portfolio-surface-strong max-[500px]:w-[5.5rem]";

const navItemActiveClass =
  "!bg-portfolio-accent font-medium uppercase !text-portfolio-inverse hover:!bg-portfolio-accent";

export default function NavBar() {
  return (
    <header className="relative flex justify-center bg-portfolio-surface p-4 after:absolute after:bottom-0 after:left-0 after:h-[2px] after:w-full after:bg-nav-divider after:content-[''] max-[1024px]:sticky max-[1024px]:top-0 max-[1024px]:z-[999] max-[1024px]:px-8 max-[1024px]:py-4 max-[768px]:p-2">
      <ul className="flex list-none gap-2 rounded-[200px] bg-portfolio-page p-1.5 text-xs font-medium max-[1024px]:w-full max-[1024px]:flex-wrap max-[1024px]:justify-center max-[1024px]:bg-transparent max-[1024px]:text-[0.8rem] max-[500px]:text-[0.7rem]">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `${navItemBaseClass} ${isActive ? navItemActiveClass : ""}`
            }
          >
            <li>{item.label}</li>
          </NavLink>
        ))}
      </ul>
    </header>
  );
}
